
export class NonProductiveManufacturingOrderCategory {
  constructor(
    public hash?: string,
    public name?: string,
    public value?: string
  ) { }

  clone() {
    return new NonProductiveManufacturingOrderCategory(
      this.hash,
      this.name,
      this.value
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/non-productive-manufacturing-order-category.ts